import { v4 as uuidv4 } from 'uuid';

const STORAGE_KEY = 'deviceId';

/** Stable per-browser profile id — one refresh session per user per device on the API. */
export function getOrCreateDeviceId() {
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = uuidv4();
      localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch {
    return uuidv4();
  }
}
